import * as CoreFrameDTOs from "coreframetypings/dto";
import Utilities from '@/Utility/Utilities';

export default class DetailViewDTOAccessor {
    constructor() {}
    
    /**
     * Entfernt ein IDVGItemDTO in einem IDetailViewDTO anhand des Namens
     * @param detailView
     * @param name
     */
    public static removeDetailViewItemDtoInDetailView(detailView: CoreFrameDTOs.IDetailViewDTO, name: string): void {
        if (Utilities.isNullOrUndefined(detailView.detailViewGroups))
            return;

        detailView.detailViewGroups.forEach(g => this.removeDetailViewItemDtoInDetailViewGroup(g, name));
    }

    /**
     * Entfernt ein IDVGItemDTO in einem IDetailViewGroupDTO anhand des Namens
     * @param detailViewGroup
     * @param name
     */
    public static removeDetailViewItemDtoInDetailViewGroup(detailViewGroup: CoreFrameDTOs.IDetailViewGroupDTO, name: string): void {
        if (Utilities.isNullOrUndefined(detailViewGroup.detailViewGroups))
            return;

        detailViewGroup.items = detailViewGroup.items.filter(i => i.name !== name);
        detailViewGroup.detailViewGroups.forEach(g => this.removeDetailViewItemDtoInDetailViewGroup(g, name));
    }

    /**
     * Entfernt ein IDetailViewGroupDTO in einem IDetailViewDTO anhand des Namens
     * @param detailView
     * @param name
     */
    public static removeDetailViewGroupDtoInDetailView(detailView: CoreFrameDTOs.IDetailViewDTO, name: string): void {
        if (Utilities.isNullOrUndefined(detailView.detailViewGroups))
            return;

        detailView.detailViewGroups = detailView.detailViewGroups.filter(g => g.name !== name);
        detailView.detailViewGroups.forEach(g => this.removeDetailViewGroupDtoInDetailViewGroup(g, name));
    }

    /**
     * Entfernt ein IDetailViewGroupDTO in einem IDetailViewGroupDTO anhand des Namens
     * @param detailViewGroup
     * @param name
     */
    public static removeDetailViewGroupDtoInDetailViewGroup(detailViewGroup: CoreFrameDTOs.IDetailViewGroupDTO, name: string): void {
        if (Utilities.isNullOrUndefined(detailViewGroup.detailViewGroups))
            return;

        detailViewGroup.detailViewGroups = detailViewGroup.detailViewGroups.filter(g => g.name !== name);
        detailViewGroup.detailViewGroups.forEach(g => this.removeDetailViewGroupDtoInDetailViewGroup(g, name));
    }

    /**
     * Findet ein IDVGItemDTO in einem IDetailViewDTO anhand des Namens
     * @param context
     * @param name
     */
    public static findDetailViewItemDtoInDetailView(context: CoreFrameDTOs.IDetailViewDTO, name: string): CoreFrameDTOs.IDVGItemDTO {
        if (!Utilities.isNullOrUndefined(context.detailViewGroups)) {
            for (let group of context.detailViewGroups) {
                const item = this.findDetailViewItemDtoInDetailViewGroup(group, name);
                if (item != null)
                    return item;
            }
        }

        return null;
    }

    /**
     * Findet ein IDVGItemDTO in einem IDetailViewGroupDTO anhand des Namens
     * @param group
     * @param name
     */
    public static findDetailViewItemDtoInDetailViewGroup(group: CoreFrameDTOs.IDetailViewGroupDTO, name: string): CoreFrameDTOs.IDVGItemDTO {
        if (!Utilities.isNullOrUndefined(group.detailViewGroups)) {
            for (let subGroup of group.detailViewGroups) {
                const item = this.findDetailViewItemDtoInDetailViewGroup(subGroup, name);
                if (item != null)
                    return item;
            }
        }

        const filteredItems = group.items.filter(g => g.name === name);
        if (filteredItems.length > 0)
            return filteredItems[0];

        return null;
    }

    /**
     * Findet ein IDetailViewGroupDTO in einem IDetailViewDTO anhand des Namens
     * @param context
     * @param name
     */
    public static findDetailViewGroupDtoInDetailView(context: CoreFrameDTOs.IDetailViewDTO, name: string): CoreFrameDTOs.IDetailViewGroupDTO {
        if (!Utilities.isNullOrUndefined(context.detailViewGroups)) {
            for (let subGroup of context.detailViewGroups) {
                if (subGroup.name === name)
                    return subGroup;
                const group = this.findDetailViewGroupDtoInDetailViewGroup(subGroup, name);
                if (group != null)
                    return group;
            }
        }

        return null;
    }

    /**
     * Findet ein IDetailViewGroupDTO in einem IDetailViewGroupDTO anhand des Namens
     * @param group
     * @param name
     */
    public static findDetailViewGroupDtoInDetailViewGroup(group: CoreFrameDTOs.IDetailViewGroupDTO, name: string): CoreFrameDTOs.IDetailViewGroupDTO {
        if (!Utilities.isNullOrUndefined(group.detailViewGroups)) {
            for (let subGroup of group.detailViewGroups) {
                if (subGroup.name === name)
                    return subGroup;
                const group = this.findDetailViewGroupDtoInDetailViewGroup(subGroup, name);
                if (group != null)
                    return group;
            }
        }

        return null;
    }
}